import styled, { createGlobalStyle } from 'styled-components';
// eslint-disable-next-line @upgrade/no-import-styles-properties
import { themeConfigs } from '@upgrade/themes';
export const GlobalTooltipStyle = createGlobalStyle`
  .tippy-box {
    font-size: ${props => props.theme.fontSizeBase};
    font-weight: ${props => props.theme.fontWeightBase};
    line-height: ${props => props.theme.lineHeightBase};
    white-space: normal;
    text-align: left;
    text-transform: none;
  }

  .tippy-box[data-theme="light"] {
    color: ${props => props.theme.palette.content};
  }

  .tippy-box[data-theme="dark"] {
    color: ${props => props.theme.palette.contentReverse};
  }
`;

// eslint-disable-next-line @upgrade/no-default-props
GlobalTooltipStyle.defaultProps = {
  theme: themeConfigs.upgrade
};
export const TooltipIconContainer = styled.div`
  margin-left: 0.25rem;
  margin-right: auto;
  padding-top: 0.125rem;
`;
export const TooltipIconInlineContainer = styled(TooltipIconContainer).attrs({
  as: 'span'
})``;
//# sourceMappingURL=styles.js.map